'use strict';

// Settings configured here will be merged into the final config object.
export default {
  MUSE_VERSION: '5.7.5',
  MUSE_BUILD: 5170
}
